import { cartClass } from './main';

class ProductCard {
    constructor(selector) {
        this.element = selector;

        this.variations = this.element.querySelectorAll('.ticket-variation');
        this.quantitySelection = this.element.querySelector('.variations--quantity');
        this.quantityMoreBtn = this.quantitySelection.querySelector('.qty-btn--plus');
        this.quantityLessBtn = this.quantitySelection.querySelector('.qty-btn--minus');
        this.quantityInput = this.quantitySelection.querySelector('.qty-input');

        this.productAddToCartBtn = this.element.querySelector('.add-to-cart--button');

        this.init();
    }
    init() {
        if(this.quantitySelection) {
            this.quantitySelectionFunctionality();
        }
        if(this.variations.length > 1) {
            this.radioSelectionFunctionality();
        }

        this.productAddToCartBtn.addEventListener('click', () => {
            const selected = this.element.querySelector('input[type="radio"]:checked');
            const quantity = parseInt(this.quantityInput.value);
            const payload = {
                action:           'cart_add',
                security:         custom_ajax_obj.security,
                product_id:       selected.dataset.productId,
                product_name:     selected.dataset.productName,
                stripe_product_id:     selected.dataset.stripeProductId,
                variation_label:  selected.dataset.variationLabel,
                stripe_price_id:         selected.dataset.stripePriceId,
                quantity:         quantity,
            };

            cartClass.addToCart(payload);
        });
    }
    quantitySelectionFunctionality() {
        this.quantityMoreBtn.addEventListener('click', () => {
            let maxValue = parseInt(this.quantityInput.getAttribute('max'));
            let currentValue = parseInt(this.quantityInput.value);
            if(currentValue < maxValue) {
                this.quantityInput.value = currentValue + 1;
            }
        });

        this.quantityLessBtn.addEventListener('click', () => {
            let minValue = parseInt(this.quantityInput.getAttribute('min'));
            let currentValue = parseInt(this.quantityInput.value);
            if(currentValue > minValue) {
                this.quantityInput.value = currentValue - 1;
            }
        });
    }
    radioSelectionFunctionality() {
        let radios = this.element.querySelectorAll('input[type="radio"]');
        radios.forEach(radio => {
            radio.addEventListener('change', () => {
                this.element.querySelectorAll('.ticket-variation').forEach(l => l.classList.remove('is-selected'));
                radio.closest('.ticket-variation').classList.add('is-selected');
                this.quantityInput.value = 1;
            });
        });
    }
}

export { ProductCard }